import React from 'react'
import { FcGoogle } from 'react-icons/fc'
import '../../app.css'
import firebase from 'firebase'
function SignIn() {
    let provider = new firebase.auth.GoogleAuthProvider();
    const db = firebase.database()
    const GSignIN = () => {
        firebase.auth()
            .signInWithPopup(provider)
            .then((result) => {
                /** @type {firebase.auth.OAuthCredential} */
                let credential = result.credential
                // This gives you a Google Access Token. You can use it to access the Google API.
                let token = credential.accessToken
                // The signed-in user info.
                let user = result.user
                let id = user.uid
                db.ref().child(`users`).child(user.uid).get().then(s => {
                    if (s.exists()) {
                        alert(`Signed in as: ${user.displayName}`)
                        window.location.href = '/'
                    }
                    else {
                        db.ref(`users/${user.uid}`).set({
                            name: user.displayName,
                            photo: user.photoURL,
                            linkid: id
                        })
                            .then(s => {

                            })
                        db.ref(`${user.uid}`).set({
                            user: user.uid
                        })
                            .then(s => {

                            })
                    }
                })
            }).catch((error) => {
                let errorMessage = error.message;
                alert("Log in failed.", errorMessage)
                console.log(errorMessage, error)
            });
    }
    return (
        <>
            < div className=' mt-4 bg-secondary p-3 col-xs-8 col-sm-10 col-xl-6 col-md-8 border-radius-2' style={{ height: "60%", marginLeft: "auto", marginRight: "auto", borderRadius: '20px' }} >
                <form className="form-signin text-primary h3 text-bold" >Sign In
                     <div className="social-login d-flex justify-content-center" onClick={GSignIN}>
                        <div id='googleSignIn'>
                            <div>
                                <FcGoogle id="GoogleLogo" />
                                <span className='text-primary'>SignIn using Google</span>
                            </div>
                        </div>
                    </div>
                    <p className='mb-2 mt-4 text-primary' style={{ "textAlign": "center" }}> OR  </p>
                    <input style={{ border: '2px solid #152238', background: '#506477', color: '#add7ff', ':placeholder': { 'color': "white" } }} type="email" id="inputEmail" className="form-control   mt-3 mb-3"
                        placeholder="Email address" required="" autoFocus="" />
                    <input style={{ border: '2px solid #152238', background: '#506477', color: '#add7ff', ':placeholder': { 'color': "#222222" } }} type="password" id="inputPassword" className="form-control mt-3 mb-3"
                        placeholder="Password" required="" />
                    <button onClick={(e) => {
                        e.preventDefault()
                    }} className="btn btn-dark text-primary btn-block mt-4 mb-1" type="submit">
                        Sign in
                    </button>
                    <a href='/reset-password' style={{ textAlign: 'right' }}>Forgot Password?</a>
                    <a href='/signup' className="btn btn-dark text-primary btn-block mt-5 mb-3" type="button" id="btn-signup">
                        Sign up New Account
                </a>
                </form>
            </div >
        </>
    )
}
export default SignIn

